module.exports = __webpack_public_path__ + "img/logo-top.158dd20e.png";